// extracted by css-extract-rspack-plugin
var _1 = "bQBRelXAbiYvalld";
var _2 = "FKS74KHGSaI64UDT";
var _3 = "hzPLqhGpHlYW7lVK";
var _4 = "YvYFhb6SE_Yke3Fb";
var _5 = "IKNaiZoEWhgUkyLr";
var _6 = "dc_Anch7WgGEmE_U";
var _7 = "yQxgg5Ksnw80eDBf";
var _8 = "xLi3ZbEXBEM_Tl9C";
export { _1 as "cardCoverImageHorizontal", _2 as "cardCoverImageVertical", _3 as "cardCoverImageVerticalLong", _4 as "figcaptionStyle", _5 as "figureStyle", _6 as "iconMargin", _7 as "imageResponsive", _8 as "textWrapperStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "bQBRelXAbiYvalld";
var _2 = "FKS74KHGSaI64UDT";
var _3 = "hzPLqhGpHlYW7lVK";
var _4 = "YvYFhb6SE_Yke3Fb";
var _5 = "IKNaiZoEWhgUkyLr";
var _6 = "dc_Anch7WgGEmE_U";
var _7 = "yQxgg5Ksnw80eDBf";
var _8 = "xLi3ZbEXBEM_Tl9C";
export { _1 as "cardCoverImageHorizontal", _2 as "cardCoverImageVertical", _3 as "cardCoverImageVerticalLong", _4 as "figcaptionStyle", _5 as "figureStyle", _6 as "iconMargin", _7 as "imageResponsive", _8 as "textWrapperStyle" }
